<template>
<div id="app">
  <mobile-coming class="uk-hidden@s"></mobile-coming>
  <div class="uk-visible@s">
    <div class="uk-offcanvas-content" style="height: 100%">
      <!-- GLOBAL PROGRESS BAR -->
      <vue-progress-bar></vue-progress-bar>      
      <!-- GLOBAL NOTIFICATIONS -->  
      <!-- used in UploadHandler to display x of total being loaded to user -->
      <notifications group="loading" width="215px" position="bottom left">
        <template slot="body" slot-scope="props">
          <div class="notification-card">
            <div class="uk-grid">
              <div class="uk-width-3-4"> 
                <a class="title">
                  {{props.item.title}}
                  <span v-html="globalImages.uploadedImages.length"></span>
                  <span> of {{props.item.data.length}} </span>
                </a>
                <a class="close" @click="props.close">
                </a>              
                <div class="notification-body" v-html="globalImages.uploadedImages[globalImages.uploadedImages.length - 1].fileName">
                </div>
              </div>
              <div class="uk-width-1-4 uk-padding-remove uk-text-center">
                <div uk-spinner class="wm-green2"></div>
              </div>
            </div>
          </div>
        </template>
      </notifications>
      <!-- EXPORTING -->
      <notifications group="exporting" width="215px" position="bottom left">
        <template slot="body" slot-scope="props">
          <div class="notification-card">
            <div class="uk-grid">
              <div class="uk-width-3-4"> 
                <a class="title">
                  {{props.item.title}} <i class="material-icons uk-inline">save_alt</i> 
                </a>
                <a class="close" @click="props.close">
                </a>              
                <div class="notification-body">Exporting {{props.item.data.length}} images.</div>
              </div>
              <div class="uk-width-1-4 uk-padding-remove uk-text-center">
                <div uk-spinner class="wm-green2"></div>
              </div>
            </div>
          </div>
        </template>
      </notifications>      
      <!-- loaded -->
      <notifications group="loaded" width="215px" position="bottom left"></notifications>  
      <!-- used in sideBarTemplate apply to display x of total being applied to user -->
      <notifications group="applying" width="215px" position="bottom left">
        <template slot="body" slot-scope="props">
          <div class="notification-card">
            <div> 
              <a class="title">
                {{props.item.title}}
                <span v-html="globalSessionInfo.counterIndex + 1"></span>
                <span> of {{props.item.data.length}} </span>
                <div uk-spinner class="wm-green2" style="float: right"></div>
              </a>
              <a class="close" @click="props.close">
              </a>              
              <div class="notification-body" v-html="globalImages.uploadedImages[globalSessionInfo.counterIndex].fileName">
              </div>
            </div>
          </div>
        </template>
      </notifications>       
      <!-- used in exportApply to display x of total being uploaded to firebase -->
      <notifications group="uploading" width="215px" position="bottom right">
        <template slot="body" slot-scope="props">
          <div class="notification-card">
            <div> 
              <a class="title">
                {{props.item.title}}
                <span v-html="globalSessionInfo.uploadingImageIndex + 1"></span>
                <span> of {{props.item.data.length}} </span>
                <div uk-spinner class="wm-green2" style="float: right"></div>
              </a>
              <a class="close" @click="props.close">
              </a>              
              <div class="notification-body" v-html="globalImages.uploadedImages[globalSessionInfo.uploadingImageIndex].fileName">
              </div>
            </div>
          </div>
        </template>
      </notifications>    
      <notifications group="uploadComplete" width="215px" position="bottom right"></notifications>

      <!-- NAVBAR -->
      <navbar></navbar>      

      <!-- Suggest maybe using <keep-alive> to limit requests to firestore!! b/c every time you visit it pulls all albums/gallery info :'(     <keep-alive></keep-alive> -->      
      <!-- BODY COMPONENTS  -->
      <router-view></router-view>
      <!-- BODY COMPONENTS -->

      <!--Feedback Module ... in App.vue to be readable from any component -->
      <div id="export-feedback-modal" uk-modal>
        <div class="uk-modal-dialog uk-modal-body uk-padding-small uk-margin-auto-vertical">
          <button class="uk-modal-close-default" type="button" uk-close></button>
            <div class="uk-modal-header">
                <div class="uk-modal-title uk-text-default uk-text-center">Feedback <i class="material-icons" style="font-size: 36px; vertical-align: middle; color: #11bb77">assignment</i></div>
            </div>
            <div class="resize-modal-body">
                <p style="font-size: 20px;">Your feedback matters!</p>
                <p>Please take a second to provide feedback so we can make this app the best it can be.</p>
                <div class="uk-margin">
                    <textarea class="uk-textarea" rows="3" placeholder="Provide feedback..." v-model="feedbackComment"></textarea>
                </div>
                <div class="uk-margin">                
                </div>                
                <!-- Rating -->
                <div class="uk-text-center" style="transform: scale(1.7);"><rate :length="5" value="0" @after-rate="submitRating"/></div>
                <div class="uk-text-center uk-margin-top">
                  <span v-if="feedbackRating > 3"><i>Thanks!</i> 😊🎉</span>
                  <span v-if="feedbackRating <= 3 && feedbackRating > 0">Thank you for the feedback. 👍</span>
                  <span v-if="feedbackRating === 0"></span>
                </div>
            </div>
            <div class="uk-modal-footer uk-modal-footer-edit uk-text-right"> 
                <button class="uk-button uk-button-default uk-modal-close" type="button">Cancel</button> 
                <button @click="submitFeedback()" class="uk-button uk-button-primary uk-margin-small-left">Submit</button> 
            </div> 
        </div>
      </div> 

      <!-- User How-To-Guide Modal -->
      <div id="how-to-guide" uk-modal>
        <div class="uk-modal-dialog  uk-margin-auto-vertical">

          <button class="uk-modal-close-default" type="button" uk-close></button>

          <div class="how-to-header uk-text-center">            
              <p class="how-to-title">How to <span class="how-to-title-bold">Watermark</span><span> Photos</span></p>
          </div>

          <div class="how-to-body" uk-overflow-auto>
              <div class="how-to-body">
                <ul class="uk-tab uk-flex-center" uk-switcher>
                  <li class="tutorial-step"><a href=""><span class="uk-badge">1</span> Create</a></li>
                  <li class="tutorial-step"><a href=""><span class="uk-badge">2</span> Apply</a></li>
                  <li class="tutorial-step"><a href=""><span class="uk-badge">3</span> Export</a></li>
                </ul>                
                <ul id="my-id" class="uk-switcher uk-margin">
                  <!-- 1) First Tab Content -->
                  <li>
                    <img class="tutorial-image" src="/img/illustrations/tutorial/create_tutorial.png"/>                
                    <div class="uk-flex uk-margin-top">
                      <div><i class="material-icons uk-inline">brush</i></div>
                      <div class="uk-margin-small-left">Watermarks are saved as <i>smart</i> Templates.</div>
                    </div>
                    <div class="uk-flex uk-margin-top">
                      <div><i class="material-icons uk-inline">zoom_out_map</i> </div>
                      <div class="uk-margin-small-left">Create one. It will automatically resize and position to the image it is applied to.</div>
                    </div> 
                    <hr>  
                    <div class="uk-text-right">
                      <button class="uk-button uk-button-default uk-modal-close uk-button-small" type="button">Close</button>                   
                      <button href="#" uk-switcher-item="next" class="uk-button uk-button-primary uk-button-small uk-margin-small-left">Next</button> 
                    </div>     
                  </li>
                  <!-- 2) Second Tab Content -->
                  <li>
                    <img class="tutorial-image" src="/img/illustrations/tutorial/apply_tutorial.png"/>                
                    <div class="uk-flex uk-margin-top">
                      <div><i class="material-icons uk-inline">add_a_photo</i></div>
                      <div class="uk-margin-small-left">Import one or dozens of images</div>
                    </div>
                    <div class="uk-flex uk-margin-top">
                      <div style="width: 22px">
                        <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" data-icon="stamp" class="svg-inline--fa fa-stamp fa-w-16" role="img" viewBox="0 0 512 512"><path fill="currentColor" d="M32 512h448v-64H32v64zm384-256h-66.56c-16.26 0-29.44-13.18-29.44-29.44v-9.46c0-27.37 8.88-53.41 21.46-77.72 9.11-17.61 12.9-38.39 9.05-60.42-6.77-38.78-38.47-70.7-77.26-77.45C212.62-9.04 160 37.33 160 96c0 14.16 3.12 27.54 8.69 39.58C182.02 164.43 192 194.7 192 226.49v.07c0 16.26-13.18 29.44-29.44 29.44H96c-53.02 0-96 42.98-96 96v32c0 17.67 14.33 32 32 32h448c17.67 0 32-14.33 32-32v-32c0-53.02-42.98-96-96-96z"/></svg>
                      </div>
                      <div class="uk-margin-small-left">Choose your saved watermark to apply</div>
                    </div>   
                    <hr>
                    <div class="uk-text-right">
                      <button class="uk-button uk-button-default uk-modal-close uk-button-small" type="button">Close</button> 
                      <button href="#" uk-switcher-item="next" class="uk-button uk-button-primary uk-button-small uk-margin-small-left">Next</button> 
                    </div>                                     
                  </li>
                  <!-- 3) Third Tab Content -->
                  <li>
                    <img class="tutorial-image" src="/img/illustrations/tutorial/export_tutorial.png"/>    
                    <div class="uk-flex uk-margin-top">
                      <div><i class="material-icons uk-inline">photo_size_select_large</i> </div>
                      <div class="uk-margin-small-left">Rename and/or resize your image(s)</div>
                    </div>   
                    <div class="uk-flex uk-margin-top">
                      <div><i class="material-icons uk-inline">save_alt</i> </div>
                      <div class="uk-margin-small-left">Export to download 🎉!</div>
                    </div>                                                                      
                    <hr>
                    <div class="uk-text-right">
                      <button class="uk-button uk-button-primary uk-modal-close uk-button-small" type="button">Done</button>                       
                    </div>                     
                  </li>
                </ul>           
              </div> 
          </div>          
        </div>
      </div>

      <!-- Register Modal -->
      <div id="register-modal" uk-modal>
        <div class="uk-modal-dialog uk-margin-auto-vertical">
          <register v-bind:registerSource="'export'"></register>        
        </div>
      </div>   
    </div>
  </div>

  <v-tour name="designTour" :steps="designSteps" :callbacks="designTourCallbacks"></v-tour>    
  <div id="bottomRight" style="position: absolute; bottom: 10px; right: 40px"></div>
</div>
</template>

<script>
import Navbar from './components/Navbar.vue'
import MobileComing from './components/MobileComing.vue'
import firebase from 'firebase/app'
import Register from './components/account/Register.vue'
import { FontPicker } from 'font-picker'

export default {
  name: 'App',
  components: {
    'navbar': Navbar,
    'mobile-coming': MobileComing,
    'register': Register
  },
  data() {
    return {
      feedbackRating: 0,
      feedbackComment: '',
      designTourCallbacks: {
        onNextStep: this.myCustomNextStepCallback
      },      
      // Design Tour
      designSteps: [
          // 1
          {
              target: '#bottomRight',  // Navbar.vue
              content: `<strong><p><i class="material-icons uk-inline wm-yellow">navigation</i> Take a tour!</p></strong>
              <p>You will <u>create and save</u> your watermarks in the CREATE mode.</p>
              <p>They will act like <u>templates</u> and can be applied to any size photo.</p>`,
              params: {
                placement: 'top',                  
              },
              modifiers: {
                arrow: {
                  enabled: false
                }
              }
          },
          // 2
          {
              target: '#aspectRatios',  // Design.vue
              content: `<p>Use any aspect ratio. Your <u>smart</u> watermark will automatically adjust it's size and position when used in Apply mode</p>
                        <i class="scale-parent" style="margin: auto;">
                          <div class="scale-animation">
                              <div class="scale-text">©LOGO</div>
                          </div>
                        </i> `,
              params: {
                  placement: 'bottom',               
              }               
          },          
          // 3
          {
            target: '#sidebarTypeFull', // SidebarPickType.vue
            content: `<strong>Full Editor</strong>             
              <ul class="uk-list uk-list-bullet uk-text-left">
                  <li>Upload your own logo</li>
                  <li>Add text (200+ fonts)</li>
              </ul>`,
            params: {
              placement: 'right',
              modifiers: {
                preventOverflow: {
                  escapeWithReference: true
                }    
              }
            }              
          },
          // 4
          {
            target: '#sidebarTypeTile', // SidebarPickType.vue
            content: `<strong>Tile</strong> 
              <ul class="uk-list uk-list-bullet uk-text-left">
                  <li>Repeat a logo over an image</li>
                  <li>Maximum protection!</li>
              </ul>`,
            params: {
              placement: 'right',
              modifiers: {
                preventOverflow: {
                  escapeWithReference: true
                }    
              }
            }
          },
          // 5
          {
            target: '#sidebarTypeBorder', // SidebarPickType.vue
            content: `<strong>Border</strong> 
              <ul class="uk-list uk-list-bullet uk-text-left">
                <li>Add a border on top of an image</li>
                <li>Add text below an image</li>
                <li>🤣 MEME ALL THE THINGS 🤣</li>
              </ul>`,
            params: {
              placement: 'right',
              modifiers: {
                preventOverflow: {
                  escapeWithReference: true
                }    
              }
            }
          },
          // 6
          {
            target: '#designSaveButton', // Design.vue
            content: `<p class="uk-margin-large-top"><i class="material-icons uk-inline">save</i> Don't forget to <strong>SAVE</strong> your watermark!</p>`,
            params: {
              placement: 'left',
              modifiers: {
                preventOverflow: {
                  escapeWithReference: true
                }    
              }
            }
          }                        
      ]       
    }      
  },
  methods: {
    myCustomNextStepCallback (currentStep) {
        // can use this area whenever something on tour is clicked
    },    
    recordError(err, desc) {
        // prompt user something went wrong 
        UIkit.modal.alert(`                  
            <div class="uk-grid-collapse uk-child-width-expand@s" uk-grid>
                <div class="uk-text-center">
                    <img class="uk-margin-top" src="/img/illustrations/doodles/error_doodle_small.png"/>
                </div>
                <div>
                    <h3 class="wm-red"><i class="material-icons uk-inline" style="color: #f4c20d; font-size: 28px;">warning</i> ERROR</h3>
                    <p class="uk-padding-remove uk-margin-remove uk-text-small"><b>${desc}</b> 
                    This has been reported to the team. Please try again later.</p>
                </div>              
            </div>                        
        `)                    

        // report exception to ga
        gtag('event', 'exception', {
            'description': '[ERROR] '+ desc + '... ' + err,
            'fatal': false
        });    
    },
    submitFeedback() {
      var me;
      me = this;

      // If user is not logged in, create temp account to track their actions
      if (this.globalSessionInfo.currentUser.isLoggedIn === false) {
        firebase.auth().signInAnonymously().catch(function(error) {
          // Handle Errors here.
          var errorCode = error.code;
          var errorMessage = error.message;
          // ...
        });    
      }

      // Save mark to firebase                
      let userId = firebase.auth().currentUser.uid;   
      let fbRef = firebase.firestore().collection('feedback').doc(userId).collection('items').doc();       

      var today = new Date();           

      fbRef.set({
        comment: this.feedbackComment.slice(0, 500),
        createdOn: today.toISOString().substring(0, 10),
        rating: this.feedbackRating,
        userAnonymous: me.globalSessionInfo.currentUser.isAnonymous   
      }) 
      .then(function() {
          // Close Modal
           UIkit.modal('#export-feedback-modal').hide()
      })
      .catch(function(error) {
          console.error("Error writing feedback: ", error);
      });  
      
    },
    submitRating(rate) {
      // This controls happy text under the rating
      this.feedbackRating = rate;
      
      var me;
      me = this;

      // If user is not logged in, create temp account to track their actions
      if (this.globalSessionInfo.currentUser.isLoggedIn === false) {
        firebase.auth().signInAnonymously().catch(function(error) {
          // Handle Errors here.
          var errorCode = error.code;
          var errorMessage = error.message;
          
          // ...
        });    
      }

      // is user logged in
      if (firebase.auth().currentUser) {
        // Save mark to firebase                
        let userId = firebase.auth().currentUser.uid;   
        let fbRef = firebase.firestore().collection('feedback').doc(userId).collection('items').doc();

        var today = new Date();
        fbRef.set({
            rating: this.feedbackRating,
            createdOn: today.toISOString().substring(0, 10)
        })
        .then(function() {
            console.log("Rating accepted!");
        })
        .catch(function(error) {
            console.error("Error writing feedback: ", error);
        });  
      } 
    },
    startDesignTour() {
      // Start Tour
      // this.$router.push('/design')
      //.then(function() {
        this.$tours['designTour'].start()
      //});  
    },
    restart: function() {
      var me;
      me = this;

      UIkit.modal.confirm('<b>Restart?</b> <br> Are you sure you want to remove <b>' + me.globalImages.uploadedImages.length + ' images</b> from queue and restart?')
        .then(function () {
          // revoke all object urls
          for (let i = 0; i < me.globalImages.uploadedImages.length; i++) {
            URL.revokeObjectURL(me.globalImages.uploadedImages[i].dataURL)
            URL.revokeObjectURL(me.globalImages.uploadedImages[i].thumbnailURL)
          }
          // cleanup
          setTimeout(function(){ 
            me.globalImages.uploadedImages = [];
            me.globalSessionInfo.compressOnImport = null; 
            me.globalSessionInfo.appliedWatermark = false;
            me.globalSessionInfo.appliedWatermarkIndex = null;
          }, 200);              

      }, function () {
      }); 
    },
  },
  mounted() {    
    // when app loads
    gtag('event', 'load', {
      'event_category':'app'
    });
    
    // Navigation Gaurds
    this.$router.beforeEach((to, from, next) => {      
      if (from.name === 'Design') {
        // close tour modal
        this.$tours['designTour'].stop()
      }
      next()
    })
  }
}
</script>

<style>
  h1, .uk-h1, h2, .uk-h2, h3, .uk-h3, h4, .uk-h4, h5, .uk-h5, h6, .uk-h6, legend {
    font-weight: 300;
    font-family: 'Poppins', sans-serif;
  }

  body { 
    overflow: hidden; 
    font-family: 'Work Sans', sans-serif;
  }

  button, .uk-button, body, .uk-navbar-item {
    font-family: 'Work Sans', -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif;
  } 

  html { 
    overflow-y: scroll; 
    background: #E4E4E4;
    height: 100%;
  }

  /* for lightgallery.js */
  @font-face {
      font-family: 'lg';
      src: url("https://cdn.jsdelivr.net/npm/lightgallery.js@1.1.3/dist/fonts/lg.woff") /* EOT file for IE */
  }

  /* Navbar */
  .navbar-text {
    font-family: 'Poppins', sans-serif !important;
  } 

  .main-navbar { 
    background: linear-gradient(to left, #00aeff, #1e87f0);
    border-bottom: 1px #e5e5e5 solid;
  }

  .uk-navbar-item {
    height: 55px;
  }

  .uk-navbar-item, .uk-navbar-nav>li>a, .uk-navbar-toggle {
    height: 55px;
    font-size: 18px;
  }  

  /* Misc */
  .uk-modal .uk-button {
    border-radius: 100px;
  }

  .uk-modal-footer {
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
  }
  
  .uk-float-right {
    margin-top: 3px;
  }

  .uk-float-left {
    margin-top: 3px;
  }

  li.uk-active {
    font-weight: 500;
  }


  .uk-modal-dialog {
    /* 5 */
    opacity: 0;
    transform: translateY(-15px);
    transition: 0.08s linear;
    transition-property: opacity, transform;
    border-radius: 5px;
  }
  
  .uk-modal .uk-button {
      border-radius: 100px;
  }

  
  .uk-float-right {
      margin-top: 3px;
  }
  
  .uk-float-left {
      margin-top: 3px;
  }
  
  /* EXPORT OFF-CANVAS */
  .uk-offcanvas-bar {
      width: 350px;
      padding: 30px 30px;
  }

  .uk-button-danger {
      background-color: #1e87f0;
      text-transform: none;
  }
  .uk-button-danger:focus, .uk-button-danger:hover {
      background-color: #0f7ae5;
      color: #fff;
  }

  .uk-button-hollow {
      border: 1px solid rgb(235, 235, 235);
      background: none;
      text-transform: none;
  }
  .uk-button-hollow:focus, .uk-button-hollow:hover {
    border: 1px solid rgb(245, 245, 245);
    background-color: rgb(235, 235, 235);      
  }  

  .uk-notification-message {
    border-radius: 4px;
    /*hero patterns*/
    background: rgba(80, 80, 80, 0.95);
    color: #ebebeb;
    text-align: center;
    box-shadow: 0px 9px 30px -6px rgba(236, 236, 236, 0.463) !important;
    font-size: 16px;
  }

  .uk-notification-message-success {
    color: #11bb77;
  }

  .profile-dropdown {
    background: linear-gradient(to bottom, rgba(255,255,255,0.15) 0%, rgba(0,0,0,0.15) 100%), radial-gradient(at top center, rgba(255,255,255,0.40) 0%, rgba(0,0,0,0.40) 120%) #989898; 
    background-blend-mode: multiply,multiply;
  }

  .noselect {
    -webkit-touch-callout: none; /* iOS Safari */
      -webkit-user-select: none; /* Safari */
      -khtml-user-select: none; /* Konqueror HTML */
        -moz-user-select: none; /* Firefox */
          -ms-user-select: none; /* Internet Explorer/Edge */
              user-select: none; /* Non-prefixed version, currently
                                    supported by Chrome and Opera */
  }  

  .li-lo {
    width: auto !important;
    color: rgba(255, 255, 255, 0.8) !important;
    background-color: rgba(255, 255, 255, 0) !important;
    border: 2px solid rgba(255, 255, 255, 0.8) !important;
    text-decoration: none !important;
    transition: 0.4s;
  }

  .li-lo:hover {
    background-color: rgba(255, 255, 255, 0.2) !important;
    color: rgba(255, 255, 255, 1) !important;
    border: 2px solid rgba(255, 255, 255, 1) !important;
    text-decoration: bold;
  }

  .li-lo-text {
    margin-left: 14px;
    margin-right: 14px;
  }

  .router-link-active {
    font-weight: 500;
    color: #fff !important;
  }

  .uk-open {
    z-index: 1000;
  }

  .uk-button-white {
    background: white;
    box-shadow: 0 0 0 1px rgba(50,50,93,.08), 0 2px 5px 0 rgba(50,50,93,.06), 0 1px 1.5px 0 rgba(0,0,0,.05), 0 1px 2px 0 rgba(0,0,0,.06);                
  }

  .uk-button-white:hover {
    background: white;
    box-shadow: 0 0 0 1px rgba(50,50,93,.1), 0 2px 5px 0 rgba(50,50,93,.1), 0 3px 9px 0 rgba(50,50,93,.08), 0 1px 1.5px 0 rgba(0,0,0,.08), 0 1px 2px 0 rgba(0,0,0,.08); 
  }
  
  div[id^="font-picker"] ul.expanded {
      min-height: 300px;
      max-height: 400px;
  }

  .dropdown-button {
        box-shadow: 0 0 0 1px rgba(50,50,93,.08), 0 2px 5px 0 rgba(50,50,93,.06), 0 1px 1.5px 0 rgba(0,0,0,.05), 0 1px 2px 0 rgba(0,0,0,.06);                
        background-color: white !important;
        border-radius: 4px; 
  }

  .dropdown-button:hover {
        box-shadow: 0 0 0 1px rgba(50,50,93,.1), 0 2px 5px 0 rgba(50,50,93,.1), 0 3px 9px 0 rgba(50,50,93,.08), 0 1px 1.5px 0 rgba(0,0,0,.08), 0 1px 2px 0 rgba(0,0,0,.08);         
        border-radius: 4px; 
  }  

  .notification-card {
    padding: 10px;
    margin: 0 5px 5px;
    font-size: 12px;
    color: #ffffff;
    background: rgb(243, 243, 243);
    border-left: 5px solid #11BB77;
    box-shadow: 0 2px 2px 0 rgba(150, 150, 150, 0.14), 0 3px 1px -2px rgba(150, 150, 150, 0.14), 0 1px 5px 0 rgba(150, 150, 150, 0.14);
  }
    .notification-card.warn {
      background: #ffb648;
      border-left-color: #f48a06;
    }
    .notification-card.error {
      background: #E54D42;
      border-left-color: #B82E24;
    }
    .notification-card.success {
      background: #68CD86;
      border-left-color: #42A85F;
    }

    /* Vue Notification Card */
    .info {
      background: rgb(255, 255, 255) !important;
      color: rgb(63, 63, 63) !important;
    }    
    .notification-card.close {
      display: none;
    }    
    
    .notification-card .title {
      font-size: 14px;
      color: black;
      font-weight: bold;
    }

    .notification-title {
      font-size: 16px;
      margin: auto;
    }

    .notification-card .notification-body {
      font-size: 10px;
      color: gray;
    }
  
  /* Feedback module */
  .resize-modal-body {
    padding: 20px 20px 10px 20px;
  }

  /* Colors */
  .wm-blue {
    color: #28a5f5 !important;
  }
  .wm-green1 {
    color: #1fb58f !important;
  }
  .wm-green2 {
    color: #11bb77 !important;
  }
  .wm-red {
    color: #f24c4e !important;
  }
  .wm-yellow {
    color: #f4c20d !important;  
  }

  /* SCROLLER */
  .scroller::-webkit-scrollbar {
    width: 10px;
    height: 10px;
  }

  .scroller::-webkit-scrollbar-thumb {
      background: rgba(139, 139, 139, 0.466);
      visibility: hidden;
      border-radius: 5px;      
  }
  .scroller:hover::-webkit-scrollbar-thumb {
      visibility:visible;
  }

  /* SIDEBAR (used on all pages) */
  .tm-sidebar-left {
    position: fixed;
    top: 55px;
    bottom: 0;
    box-sizing: border-box;
    width: 220px !important;
    padding: 0 10px 0 20px; /* add extra pad to left to match scrollbar pad */
    border-right: 1px #e5e5e5 solid;
    overflow-y: scroll;
    overflow-x: hidden;
    background: #F5F5F5;
  }  

  /* COOL CHECKMARK */
  .checkmark {    
    width: 35px;
    height: 35px;
    border-radius: 50%;
    display: block;
    float: right;
    stroke-width: 2;
    stroke: #1fb58f;
    stroke-miterlimit: 10;
    box-shadow: inset 0px 0px 0px white;
    animation: fill .4s ease-in-out .4s forwards, scale .3s ease-in-out .9s both;
  }

  .checkmark__circle {
    stroke-dasharray: 166;
    stroke-dashoffset: 166;
    stroke-width: 2;
    stroke-miterlimit: 10;
    stroke: white;
    fill: none;
    animation: stroke 0.6s cubic-bezier(0.65, 0, 0.45, 1) forwards;
  }

  .checkmark__check {
    transform-origin: 50% 50%;
    stroke-dasharray: 48;
    stroke-dashoffset: 48;
    animation: stroke 0.3s cubic-bezier(0.65, 0, 0.45, 1) 0.8s forwards;
  }

  @keyframes stroke {
    100% {
      stroke-dashoffset: 0;
    }
  }
  @keyframes scale {
    0%, 100% {
      transform: none;
    }
    50% {
      transform: scale3d(1.1, 1.1, 1);
    }
  }
  @keyframes fill {
    100% {
      box-shadow: inset 0px 0px 0px 30px white;
    }
  }

  /* SPINNY LOADER <div class="loader">Loading...</div>*/
  .loader,
  .loader:before,
  .loader:after {
    border-radius: 50%;
  }
  .loader {
    color: #ffffff;
    font-size: 11px;
    text-indent: -99999em;
    margin: 55px auto;
    position: relative;
    width: 10em;
    height: 10em;
    box-shadow: inset 0 0 0 1em;
    -webkit-transform: translateZ(0);
    -ms-transform: translateZ(0);
    transform: translateZ(0);
  }
  .loader:before,
  .loader:after {
    position: absolute;
    content: '';
  }
  .loader:before {
    width: 5.2em;
    height: 10.2em;
    background: #0dc5c1;
    border-radius: 10.2em 0 0 10.2em;
    top: -0.1em;
    left: -0.1em;
    -webkit-transform-origin: 5.2em 5.1em;
    transform-origin: 5.2em 5.1em;
    -webkit-animation: load2 2s infinite ease 1.5s;
    animation: load2 2s infinite ease 1.5s;
  }
  .loader:after {
    width: 5.2em;
    height: 10.2em;
    background: #0dc5c1;
    border-radius: 0 10.2em 10.2em 0;
    top: -0.1em;
    left: 5.1em;
    -webkit-transform-origin: 0px 5.1em;
    transform-origin: 0px 5.1em;
    -webkit-animation: load2 2s infinite ease;
    animation: load2 2s infinite ease;
  }
  @-webkit-keyframes load2 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
  @keyframes load2 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }


  /* Scaling Animation */
  .scale-parent {
    height: 120px;
    width: 120px;
    display: flex;
    justify-content: center;
    align-items: center;  
  }


  .scale-text {
    font-style: normal;
    color: white;
    position: absolute;
    bottom: 10px;
    right: 10px;
  }

  .scale-animation {
      animation: change-aspect 4s infinite;
      border-radius: 3px;
      position: relative;
  }

  @keyframes change-aspect {
    /* first frame - square (blue) */
    0% {
      width: 100px;
      height: 100px;
      background: #28a5f5;
      font-size: 12px;
    }
    /* morph 1 - portrait (green) */
    25% {
      width: 80px;
      height: 120px;
      background: #11bb77;
      font-size: 10px;
    }
    33% {
      width: 80px;
      height: 120px;
      background: #11bb77;
      font-size: 10px;
    }
    /* morph 2 - landscape (yellow) */
    50% {
      width: 120px;
      height: 80px;
      background: #f4c20d;
      font-size: 15px;
    }
    66% {
      width: 120px;
      height: 80px;
      background: #f4c20d;
      font-size: 15px;
    }
    /* morph 3 - square (blue) */
    85% {
      width: 100px;
      height: 100px;
      background: #28a5f5;
      font-size: 12px;
    }  
    100% {
      width: 100px;
      height: 100px;
      background: #28a5f5;
      font-size: 12px;
    }
  }  

  /* Tutorial */
  .how-to-title {
    padding: 15px 0 15px 0;
    font-size: 24px;
    margin: 0px;
  }

  .how-to-body {
    text-transform: none !important;
    padding: 0 30px 0 30px;
  }
  .uk-tab a {
    text-transform: none !important;
  }

  .how-to-title-bold {
    font-weight: bold;
    background: -webkit-linear-gradient(#9fd3f3, #28a5f5);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;    
  }

  .tutorial-image {
    display:block;
    margin:auto;  
    border-top-right-radius: 5px;
    border-top-left-radius: 5px;
    border: 1px solid lightgray;
  }

.uk-tab .uk-active a {
  border-width:2px;
}


</style>
